import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { PaginatedResponse, StyleIdData } from "@/types/common.types";
import { useInfiniteQuery } from "@tanstack/react-query";

export type JobStyleDataItem = {
  id: number;
  processTime: string;
  status: "SUCCESS" | "FAILURE" | string;
  pdpData: StyleIdData;
  jobStyleAssignment: {
    id: number;
  };
};

export type JobStyleDataResponse = PaginatedResponse<JobStyleDataItem>;

const getJobStyleData = async ({
  pageParam,
  jobId,
  size = 50,
  styleId,
}: {
  pageParam: number;
  jobId: string;
  size: number;
  styleId?: string;
}): Promise<JobStyleDataResponse> => {
  return apiClient
    .get(
      ENDPOINTS.GET_SCHEDULED_JOB_STYLE_DETAILS(jobId, pageParam, size, styleId)
    )
    .json<JobStyleDataResponse>();
};

export const useJobStyleDataQuery = (
  jobId: string | null,
  size: number = 50,
  styleId?: string
) => {
  return useInfiniteQuery({
    queryKey: ["jobStyleData", jobId, size, styleId] as const,
    initialPageParam: 0,
    queryFn: async ({ pageParam }) => {
      if (jobId === null) {
        throw new Error("jobId is null");
      }
      return getJobStyleData({ pageParam, jobId, size, styleId });
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined;
      }
      return lastPage.page + 1;
    },
  });
};
